import { machGetCookie, machSetCookie, machSetDynamicHeaderHeight } from "./main";

jQuery(document).ready(function () {
    jQuery(document).on("click", ".close-site-alert", machCloseSiteAlert);
});

export function machSetAlertVisibility(alert) {
    let $alertWrapper = jQuery(".global-site-alert-wrapper");
    if ($alertWrapper.length) {
        let alertId = machGetCookie("mach_show_alert");
        if (alertId != alert.alert_id) {
            setTimeout(function () {
                $alertWrapper.append(alert.html);
                $alertWrapper.removeClass("translate-y-full");
            }, 2500);
        }
    }
}

function machCloseSiteAlert(e) {
    let $alertWrapper = jQuery(this).parents(".global-site-alert-wrapper");
    let $alertBlock = jQuery(this).parents(".global-site-alert");
    $alertWrapper.hide();
    machSetDynamicHeaderHeight();

    //Create a cookie containing the alert ID so it is not shown again for 24 hours
    machSetCookie("mach_show_alert", $alertBlock.data("alert-id"), 24);

    e.preventDefault();
}
